'use client';

import type { Select as ReactUISelect } from '@pickleballinc/react-ui';
import dynamic from 'next/dynamic';
import type { ComponentProps } from 'react';

export const Select = dynamic<ComponentProps<typeof ReactUISelect>>(
  () => import('@pickleballinc/react-ui').then((m) => ({ default: m.Select })),
  { ssr: false }
);
